export const SAVE_ACTIVITY = "save_activity"
export const PENDING_ACTIVITY = "pending_activity"
export const MARK_ATTENDANCE = "mark_attendance";
export const ACCOUNT_LIST = 'account_list'
export const ACCOUNT_BY_LEAD_ID = 'account_by_lead_id'